import React, { useEffect } from 'react';
import config from '../../config';
import Access from '../../Utils/authorize';

export default function AuthProvider({ children, noAccess = () => <NoAccess /> }) {
    console.log(Access.user())

    useEffect(() => {
        return () => {
            console.log('Unmount')
        }
    }, [])

    if (Access.user())
        return children
    else
        return noAccess()
}

function NoAccess() {
    const SIGN_IN_URL = `${config.REACT_APP_COGNITO_URL}/login?response_type=code&client_id=${config.REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${config.REACT_APP_COGNITO_SIGNIN}&scope=${config.REACT_APP_COGNITO_SCOPE}`

    useEffect(() => {
        window.location.href = SIGN_IN_URL
    }, [SIGN_IN_URL])

    return <p>Redirecting to Login Page...</p>
}